export default __webpack_public_path__ + "static/media/banner.34e1df1b.png";